import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 查看应用列表
  getRealmsClients: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/clients`, "get", config),
  // 查看应用列表（个人模式下）
  getPortalClients: (realmName, userName, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/users/${userName}/clients`,
      "get",
      config
    ),
  // 添加应用
  postRealmsClient: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/clients`, "post", config),
  // 查看应用详情
  getRealmsClientInfo: (realmName, clientId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}`,
      "get",
      config
    ),
  // 更新应用信息
  putRealmsClientInfo: (realmName, clientId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}`,
      "put",
      config
    ),
  // 更新应用信息
  _putRealmsClientInfo: (realmName, clientId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}`,
      "put",
      config,
      {
        neverLoading: true
      }
    ),
  // 删除应用信息
  deleteRealmsClientInfo: (realmName, clientId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}`,
      "delete",
      config
    ),
  // 应用角色列表
  getRealmsClientRole: (realmName, clientId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}/roles`,
      "get",
      config
    ),
  // 给应用添加角色
  postRealmsClientRole: (realmName, clientId, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}/roles`,
      "post",
      config
    ),
  // 更新应用的角色
  putRealmsClientRole: (realmName, clientId, roleMark, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}/roles/${roleMark}`,
      "put",
      config
    ),
  // 删除应用角色
  deleteRealmsClientRole: (realmName, clientId, roleMark, config) =>
    createAPI(
      `/idaas/admin/realms/${realmName}/clients/${clientId}/roles/${roleMark}`,
      "delete",
      config
    ),
  setDoubleFactor: (realmName, config) => 
   createAPI(
    `/idaas/admin/realms/${ realmName }/login/clientDoubleFactor`,
    "put",
    config
  ),
  getDoubleFactor: (realmName, clientId, config) => 
    createAPI(
    `/idaas/admin/realms/${ realmName }/login/clientDoubleFactor?client=${clientId}`,
    "get",
    config
  ),
}
